import createReactComponent from '../createReactComponent';
var XSquare = createReactComponent('XSquare', [['rect', {
  x: '3',
  y: '3',
  width: '18',
  height: '18',
  rx: '2',
  ry: '2',
  key: 'maln0c'
}], ['line', {
  x1: '9',
  y1: '9',
  x2: '15',
  y2: '15',
  key: '10u9bu'
}], ['line', {
  x1: '15',
  y1: '9',
  x2: '9',
  y2: '15',
  key: '19zs77'
}]]);
export default XSquare;